import { IconProps, iconA11yProps } from '../types';

export const Cut = ({ classNames, label }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24" className={classNames} fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...iconA11yProps(label)}>
        <path d="M5 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" /><path d="M15 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" /><path d="M7.15 14.85l8.85 -10.85" /><path d="M4 4l8.85 10.85" />
    </svg>
);
